module.exports = __webpack_public_path__ + "img/academy.959d3002.svg";